import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(false, {

    [actions.TOGGLE_POLYGON_MODE]: (state, action) => !state,

    [actions.SELECT_WITH_POLYGON]: (state, action) => false

})


// WEBPACK FOOTER //
// ./src/reducers/selectWithPolygon.js